import React from 'react'
import { Card } from 'react-bootstrap'
import { IconButton, Button } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { COLORES } from '../../../../config/colores'

function DialogoAnuncioBuquesDelete (props) {
  const { handleClose, handleSubmit, handleCancelar } = props

  return (
    <Card style={{ border: 'none' }}>
      <Card.Header>
        <IconButton
          onClick={handleClose}
          style={{ margin: '0', padding: '5px 0', float: 'right' }}
        >
          <CloseIcon style={{ color: COLORES.grey.dark }} />
        </IconButton>
        <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>
          Cancelar o eliminar anuncio
        </Card.Text>
      </Card.Header>
      <Card.Body style={{ width: '80%', margin: '0 auto' }}>
        <Card.Text style={{ textAlign: 'center' }}>
          <strong>Cancelar anuncio:</strong> cuando un buque fue asignado a otro giro o su carga fue cancelada por algún motivo.
        </Card.Text>
        <Card.Text style={{ textAlign: 'center' }}>
          <strong>Eliminar anuncio:</strong> cuando fue registrado erroneamente.
        </Card.Text>
        <Card.Text style={{ textAlign: 'center' }}>
          Elija la opción que corresponda.
        </Card.Text>
      </Card.Body>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{ margin: '2%' }}
          onClick={handleCancelar}
          size='small'
          variant='contained'
          color='primary'
        >
          Cancelar anuncio
        </Button>
        <Button
          style={{ margin: '2%' }}
          onClick={handleSubmit}
          size='small'
          variant='contained'
          color='primary'
        >
           Eliminar anuncio
        </Button>
      </div>
    </Card>
  )
}

export default DialogoAnuncioBuquesDelete
